export class NotFound extends Error {
  data?: any;

  constructor(data?: any) {
    super('Não encontrado!');
    this.name = 'NotFound';
    this.data = data;
  }
}
